import { DrawerCard, DrawerField, DrawerTitle, Tooltip } from "@mixitone/components";
import { ApplicationView } from "@mixitone/mvc";
import { isNil } from "@mixitone/util";
import Form from "components/Forms/Form";
import FormButtons from "components/Forms/FormButtons";
import { DrawerFormFieldset } from "components/Forms/FormRenderers/DrawerFormRenderer";
import { TournamentEntryFormController } from "components/Forms/TournamentEntryForm";
import EntryMatchesSection from "components/Pages/Tournament/TournamentEntries/EntryMatchesSection";
import { DrawerContextLink } from "components/common/DrawerContextLink";
import { RoutedDrawer } from "components/common/RoutedDrawer";
import { injectModal } from "lib/injectParams";

const EditEntryDrawer = TournamentEntryFormController.scope(
  ApplicationView((_props: { id: string; tournamentSessionId: string }) => {
    const controller = TournamentEntryFormController.use();
    const { loading, record, formatDataSchema } = controller.state;
    const fields = Object.values(controller.fields());

    const contextLink = (
      <DrawerContextLink context="tournamentEntries" params={{ id: controller.props.tournamentSessionId }} />
    );

    if (loading)
      return (
        <RoutedDrawer spinner>
          <DrawerTitle contextLink={contextLink}>Edit entry</DrawerTitle>
        </RoutedDrawer>
      );

    return (
      <RoutedDrawer>
        <DrawerTitle contextLink={contextLink}>Edit entry</DrawerTitle>
        <Form name="entry">
          <div className="space-y-6">
            <DrawerFormFieldset fields={fields} />
            <FormButtons />

            {/* Format data schema display - only shown in edit mode */}
            {formatDataSchema.length > 0 &&
              record.format_data &&
              Object.keys(record.format_data).length > 0 && (
                <DrawerCard title="Competition info">
                  {formatDataSchema.map((field) => {
                    const value = field.value
                      ? field.value(record.format_data)
                      : record.format_data?.[field.key];
                    if (isNil(value)) return null;

                    return (
                      <DrawerField
                        key={field.key}
                        label={
                          <span>
                            {field.label} {field.description && <Tooltip icon>{field.description}</Tooltip>}
                          </span>
                        }
                      >
                        {field.formatter ? field.formatter(value) : String(value)}
                      </DrawerField>
                    );
                  })}
                </DrawerCard>
              )}

            {record.id && record.tournament_competition_id && (
              <EntryMatchesSection competitionId={record.tournament_competition_id} entryId={record.id} />
            )}
          </div>
        </Form>
      </RoutedDrawer>
    );
  }),
);

const ParamWrapper = ({ id, entryId }: { id: string; entryId: string }) => {
  return <EditEntryDrawer id={entryId} tournamentSessionId={id} attributes={{}} />;
};

export default injectModal(ParamWrapper);
